import React, { Component } from 'react';

class HowCanHelpTwo extends Component {
  render() {
    return (
      <section
        className='section cm-how-can-help bg-light-gray bg-cover'
        style={{ backgroundImage: 'url(assets/images/bg-help.png)' }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='mb-30 text-center'>
                <h2 className='section-heading h1 text-dark'>Here's How We Can Help You</h2>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='block bg-cover mt-30' style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}>
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/01.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>On-Site Support</h4>
                  <p className='mt-15'>
                    Visit our Willow Grove, PA store, and our experts will take care of your tech, no appointment
                    necessary.
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
            <div className='col-lg-4 col-md-6'>
              <div
                className='block active bg-cover mt-30'
                style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}
              >
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/02.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>Remote Support</h4>
                  <p className='mt-15'>
                    Access fast and reliable remote support to fix your tech issues from anywhere, anytime.
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='block bg-cover mt-30' style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}>
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/03.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>Fast Service</h4>
                  <p className='mt-15'>
                    Get your cellphone repaired quickly and efficiently with our fast, expert repair services.
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='block bg-cover mt-30' style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}>
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/04.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>Cut Costs</h4>
                  <p className='mt-15'>
                    Cut costs on cellphone repair with affordable, quality solutions that save you time and money.
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='block bg-cover mt-30' style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}>
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/05.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>Have a Backup Plan</h4>
                  <p className='mt-15'>
                    Always have a backup plan with reliable cellphone repair services to prevent unexpected issues."
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='block bg-cover mt-30' style={{ backgroundImage: 'url(assets/images/bg-help-item.jpg)' }}>
                <div className='context'>
                  <div className='icon'>
                    <img src={process.env.PUBLIC_URL + '/assets/images/help/06.png'} alt='' loading="lazy" />
                  </div>
                  <h4 className='text-dark font-w-700'>Phone accessories available. </h4>
                  <p className='mt-15'>
                    Shop our wide selection of cellphone accessories to enhance your device with style and function.
                  </p>
                </div>
              </div>
              {/* how-can-help item */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HowCanHelpTwo;
